import { render, staticRenderFns } from "./showJuryEdition.vue?vue&type=template&id=7522e9bb"
import script from "./showJuryEdition.vue?vue&type=script&lang=js"
export * from "./showJuryEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports